import React from 'react';
import { colors } from '../../../theme';
import { S } from '../dashboardStyles';
import EmptyState from '../EmptyState';
import { CreateLinkSheet, QRSheet } from '../Sheets';
import Dialpad from '../Dialpad';
import {
  Phone, Copy, Share2, Trash2, PhoneCall, Check,
  Plus, QrCode
} from 'lucide-react';

export default function CallsTab({
  links, linkStatuses, loadError, copied,
  showDialpad, setShowDialpad,
  showCreateSheet, setShowCreateSheet,
  newLabel, setNewLabel, maxParticipants, setMaxParticipants,
  ttlHours, setTtlHours, loading,
  createLink, copyLink, deleteLink,
  joinLinkRoom, dismissLinkGuest,
  qrUrl, setQrUrl,
  callUser, getLinkUrl, fmtDate, utc,
}) {
  return (
    <div>
      {loadError && <div style={S.errorBanner}>{loadError}</div>}
      {links.length === 0 && <EmptyState icon={Phone} text="Создайте первую ссылку" sub="Нажмите + внизу" />}
      <div style={S.cardList}>
        {links.map(link => {
          const status = linkStatuses[link.code];
          const isWaiting = status?.status === 'guest_waiting';
          const isInCall = status?.status === 'in_call';
          const isExpired = link.expires_at && utc(link.expires_at) < new Date();
          const url = getLinkUrl(link);

          return (
            <div key={link.code} style={{
              ...S.card,
              ...(isWaiting ? S.cardGlow : {}),
              ...(isInCall ? S.cardActive : {}),
            }}>
              {/* Header row */}
              <div style={S.cardTop}>
                <div style={{
                  ...S.cardDot,
                  background: isWaiting ? colors.greenDot : isInCall ? colors.greenDot : colors.gray200,
                  ...(isWaiting ? { animation: 'miniPulse 1.5s infinite' } : {}),
                }} />
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={S.cardTitle}>{link.label || link.code}</div>
                </div>
                <div style={S.cardMeta}>
                  {isWaiting ? 'Гость ожидает' : isInCall ? 'В звонке' : `${link.call_count || 0} звонков`}
                </div>
              </div>

              {/* Waiting state: answer/decline buttons */}
              {isWaiting && (
                <div style={S.cardCallActions}>
                  <button onClick={() => joinLinkRoom(link)} style={S.answerBtn}>
                    <PhoneCall size={14} /> Ответить
                  </button>
                  <button onClick={() => dismissLinkGuest(link.code, link.room_number)} style={S.declineBtn}>
                    Отклонить
                  </button>
                </div>
              )}

              {/* Normal state: URL + actions */}
              {!isWaiting && (
                <>
                  <div style={S.cardUrl}>{url}</div>
                  {link.expires_at && (
                    <div style={{ fontSize: 11, color: isExpired ? colors.red : colors.gray400, marginBottom: 4 }}>
                      {isExpired ? 'Истекла' : `До ${fmtDate(link.expires_at)}`}
                    </div>
                  )}
                  <div style={S.cardActions}>
                    <button onClick={() => copyLink(url)} style={{ ...S.cardBtn, ...(copied === url ? S.cardBtnActive : {}) }}>
                      {copied === url ? <Check size={14} /> : <Copy size={14} />}
                      <span>{copied === url ? 'Скопировано' : 'Копировать'}</span>
                    </button>
                    <button onClick={() => setQrUrl(url)} style={S.cardBtn}>
                      <QrCode size={14} />
                    </button>
                    <button onClick={() => { if (navigator.share) navigator.share({ url, title: 'Voxiox' }); else copyLink(url); }} style={S.cardBtn}>
                      <Share2 size={14} />
                    </button>
                    <button onClick={() => deleteLink(link.code)} style={{ ...S.cardBtn, color: colors.red }}>
                      <Trash2 size={14} />
                    </button>
                  </div>
                </>
              )}
            </div>
          );
        })}
      </div>
      {/* FABs */}
      <div style={{ position: 'fixed', bottom: 'calc(80px + env(safe-area-inset-bottom, 0px))', right: 20, display: 'flex', flexDirection: 'column', gap: 12, zIndex: 30 }}>
        <button onClick={() => setShowDialpad(true)} style={{ ...S.fab, position: 'relative', bottom: 'auto', right: 'auto', background: colors.green }}>
          <Phone size={22} color="#15141a" strokeWidth={2.5} />
        </button>
        <button onClick={() => setShowCreateSheet(true)} style={{ ...S.fab, position: 'relative', bottom: 'auto', right: 'auto' }}>
          <Plus size={24} color="#15141a" strokeWidth={2.5} />
        </button>
      </div>
      {showDialpad && <Dialpad onCall={(digits) => { setShowDialpad(false); callUser(digits); }} onClose={() => setShowDialpad(false)} />}
      {showCreateSheet && <CreateLinkSheet newLabel={newLabel} setNewLabel={setNewLabel} maxParticipants={maxParticipants} setMaxParticipants={setMaxParticipants} ttlHours={ttlHours} setTtlHours={setTtlHours} loading={loading} onCreate={createLink} onClose={() => setShowCreateSheet(false)} />}
      {qrUrl && <QRSheet url={qrUrl} onClose={() => setQrUrl(null)} onCopy={() => copyLink(qrUrl)} />}
    </div>
  );
}
